









export default {
    name: 'DealerSearchLayout',    

};
